import React, { FC } from 'react';
import { FormControl, FormControlProps } from './index';
import {
  Radio as ChakraRadio,
  RadioGroup as ChakraRadioGroup,
  RadioGroupProps as ChakraRadioGroupProps,
  RadioProps as ChakraRadioProps,
  VStack,
} from '@cardboard-ui/react';

interface RadioProps extends ChakraRadioProps {
  value: string;
  defaultChecked?: boolean;
}

export const Radio = ({ value, defaultChecked }: RadioProps) => {
  return <ChakraRadio defaultChecked={defaultChecked}>{value}</ChakraRadio>;
};

export const RadioGroup: FC<FormControlProps & ChakraRadioGroupProps> = ({
  formid,
  label,
  isOptional,
  errorMessage,
  helpText,
  introText,
  children,
  ...props
}) => {
  return (
    <FormControl
      formid={formid}
      errorMessage={errorMessage}
      helpText={helpText}
      isOptional={isOptional}
      introText={introText}
      label={label}
    >
      <ChakraRadioGroup id={formid} {...props}>
        <VStack spacing={2} alignItems="start">
          {children}
        </VStack>
      </ChakraRadioGroup>
    </FormControl>
  );
};
